import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e9ddb63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Get Started", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading-title" }, "Log in with:", -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "accordion-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "MyBenefits Account", -1))
const _hoisted_8 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Registration Code", -1))
const _hoisted_10 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_11 = { class: "form-group mb-3" }
const _hoisted_12 = {
  for: "registrationCode",
  class: "form-label"
}
const _hoisted_13 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_14 = { class: "form-group mb-3" }
const _hoisted_15 = {
  for: "ssn",
  class: "form-label"
}
const _hoisted_16 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_17 = { class: "captcha-container" }
const _hoisted_18 = { class: "google-recaptcha" }
const _hoisted_19 = { class: "form-group mt-4" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Personal Information", -1))
const _hoisted_22 = {
  key: 0,
  class: "accordion-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PandALogin = _resolveComponent("PandALogin")!
  const _component_ToolTip = _resolveComponent("ToolTip")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_SearchParticipants = _resolveComponent("SearchParticipants")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_ctx.isFormInvalid)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert alert-danger",
          innerHTML: _ctx.validationMsg
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.getAutoLogoutMsg)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "alert alert-info",
          innerHTML: _ctx.getAutoLogoutMsg
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["accordion", { active: _ctx.activeIndex === 0 }])
      }, [
        _createElementVNode("div", {
          class: "accordion-header",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAccordion(0)))
        }, [
          _hoisted_7,
          _createElementVNode("button", {
            class: _normalizeClass(["arrow", { collapsed: _ctx.activeIndex !== 0 }])
          }, null, 2)
        ]),
        (_ctx.activeIndex === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.userDataSubmit && _ctx.userDataSubmit(...args)), ["prevent"]))
              }, [
                _createVNode(_component_PandALogin)
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["accordion", { active: _ctx.activeIndex === 1 }])
      }, [
        _createElementVNode("div", {
          class: "accordion-header",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleAccordion(1)))
        }, [
          _hoisted_9,
          _createElementVNode("button", {
            class: _normalizeClass(["arrow", { collapsed: _ctx.activeIndex !== 1 }])
          }, null, 2)
        ]),
        (_ctx.activeIndex === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("form", {
                onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.userDataSubmit && _ctx.userDataSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, [
                    _createTextVNode("Registration Code "),
                    _createVNode(_component_ToolTip, { tooltipText: "To access your registration code, please refer to your P&A Group Qualifying event Notice, registration code is located on the page called COBRA Election Portal." })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    maxlength: "8",
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.registrationCode) = $event)),
                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideErrors('registrationCode'))),
                    onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isSubmitDisabled = false)),
                    id: "registrationCode",
                    class: _normalizeClass(["form-control type-number", 
                  _ctx.v$.user.registrationCode.$error ? 'is-invalid' : 'input-text'
                ])
                  }, null, 34), [
                    [_vModelText, _ctx.user.registrationCode]
                  ]),
                  (_ctx.v$.user.registrationCode.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_ctx.v$.user.registrationCode.$invalid)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({ 'is-invalid': _ctx.v$.user.registrationCode.$error })
                            }, " Please enter a valid registration code ", 2))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, [
                    _createTextVNode("SSN "),
                    _createVNode(_component_ToolTip, { tooltipText: "Enter your full SSN.  If your previous employer uses an alternative identifier, please refer to your Qualifying Event Notice for your alternative identifier." })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.ssn) = $event)),
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hideErrors('ssn'))),
                    onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isSubmitDisabled = false)),
                    "data-maska": "*##-##-####",
                    id: "ssn",
                    class: _normalizeClass(["form-control type-number", _ctx.v$.user.ssn.$error ? 'is-invalid' : 'input-text'])
                  }, null, 34), [
                    [_vModelText, _ctx.user.ssn],
                    [_directive_maska]
                  ]),
                  (_ctx.v$.user.ssn.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_ctx.v$.user.ssn.$invalid)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({ 'is-invalid': _ctx.v$.user.ssn.$error })
                            }, " Please enter a valid SSN ", 2))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createVNode(_component_vue_recaptcha, {
                      class: "w-100",
                      size: "normal",
                      sitekey: _ctx.googleRecaptchaKey,
                      theme: "light",
                      "loading-timeout": _ctx.loadingTimeout,
                      onVerify: _ctx.recaptchaVerified,
                      onExpire: _ctx.recaptchaExpired,
                      onFail: _ctx.recaptchaFailed,
                      onError: _ctx.recaptchaError,
                      ref: "vueRecaptcha"
                    }, null, 8, ["sitekey", "loading-timeout", "onVerify", "onExpire", "onFail", "onError"]), [
                      [_vShow, _ctx.showRecaptcha]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    disabled: _ctx.v$.user.$invalid || _ctx.isSubmitDisabled,
                    class: _normalizeClass(["btn w-100", [_ctx.buttonDesign()]]),
                    id: "button-continue",
                    type: "submit",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.userDataSubmit && _ctx.userDataSubmit(...args)))
                  }, " CONTINUE ", 10, _hoisted_20)
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["accordion", { active: _ctx.activeIndex === 2 }])
      }, [
        _createElementVNode("div", {
          class: "accordion-header",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleAccordion(2)))
        }, [
          _hoisted_21,
          _createElementVNode("button", {
            class: _normalizeClass(["arrow", { collapsed: _ctx.activeIndex !== 2 }])
          }, null, 2)
        ]),
        (_ctx.activeIndex === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("form", {
                onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.userDataSubmit && _ctx.userDataSubmit(...args)), ["prevent"]))
              }, [
                _createVNode(_component_SearchParticipants)
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}